"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GmxPoolCode = void 0;
const chain_1 = require("@zenlink-interface/chain");
const tiny_invariant_1 = __importDefault(require("tiny-invariant"));
const viem_1 = require("viem");
const HEXer_1 = require("../../HEXer");
const PoolCode_1 = require("./PoolCode");
class GmxPoolCode extends PoolCode_1.PoolCode {
    constructor(pool, providerName) {
        super(pool, providerName);
        this.executor = {
            [chain_1.ParachainId.MOONBEAM]: '0x7Ad8989699D44d1b9DA30cfFe82904c108e20Db0',
        };
        this.vault = {
            [chain_1.ParachainId.MOONBEAM]: '0x73197B461eA369b36d5ee96A1C9f090Ef512be21',
        };
    }
    getProtocolExecutor() {
        const chainId = this.pool.token0.chainId;
        (0, tiny_invariant_1.default)(chainId !== undefined, 'GmxPoolCode: Unseted chainId');
        return this.executor[Number(chainId)];
    }
    getProtocolExecutorStartPoint() {
        const chainId = this.pool.token0.chainId;
        (0, tiny_invariant_1.default)(chainId !== undefined, 'GmxPoolCode: Unseted chainId');
        return this.vault[Number(chainId)];
    }
    getSwapCodeForRouteProcessor(_leg, _route, _to) {
        return 'unsupported';
    }
    getSwapCodeForRouteProcessor2(leg, _route, to) {
        const code = new HEXer_1.HEXer()
            .uint8(4) // gmx pool
            .address(this.pool.address)
            .address(leg.tokenTo.address)
            .address(to)
            .toString();
        return code;
    }
    getSwapCodeForAggregationRouter(leg, _route, to) {
        const code = new HEXer_1.HEXer()
            .address(this.getProtocolExecutor())
            .bytes((0, viem_1.encodeAbiParameters)((0, viem_1.parseAbiParameters)('address, address, address'), [
            this.getProtocolExecutorStartPoint(),
            leg.tokenTo.address,
            to,
        ]))
            .toString();
        return code;
    }
}
exports.GmxPoolCode = GmxPoolCode;
